var map = {
	"./404.svg": 2617,
	"./Diagnosismanagement.svg": 621,
	"./Functionmanagement.svg": 6315,
	"./GeneralSetting.svg": 5430,
	"./HealthManagement.svg": 6956,
	"./application.svg": 4684,
	"./bug.svg": 1796,
	"./build.svg": 497,
	"./button.svg": 1798,
	"./caigj.svg": 8456,
	"./cascader.svg": 9694,
	"./chart.svg": 4509,
	"./checkbox.svg": 2315,
	"./clipboard.svg": 2139,
	"./code.svg": 3696,
	"./color.svg": 5263,
	"./component.svg": 7538,
	"./dashboard.svg": 8765,
	"./date-range.svg": 9566,
	"./date.svg": 3812,
	"./diangj.svg": 4592,
	"./dict.svg": 3610,
	"./documentation.svg": 7594,
	"./download.svg": 7084,
	"./drag.svg": 1014,
	"./druid.svg": 5917,
	"./edit.svg": 7546,
	"./education.svg": 1046,
	"./email.svg": 4413,
	"./example.svg": 9362,
	"./excel.svg": 5130,
	"./exit-fullscreen.svg": 3556,
	"./eye-open.svg": 7311,
	"./eye.svg": 8090,
	"./form.svg": 5992,
	"./fullscreen.svg": 8972,
	"./functionList.svg": 8909,
	"./github.svg": 3496,
	"./guide.svg": 2164,
	"./icon.svg": 7164,
	"./indexDis.svg": 1006,
	"./input.svg": 3201,
	"./international.svg": 2054,
	"./job.svg": 6351,
	"./kegj.svg": 9370,
	"./language.svg": 7487,
	"./link.svg": 4173,
	"./list.svg": 5091,
	"./lock.svg": 6179,
	"./log.svg": 3961,
	"./logininfor.svg": 8139,
	"./message.svg": 7124,
	"./money.svg": 2234,
	"./monitor.svg": 6570,
	"./myjob.svg": 7182,
	"./nested.svg": 9380,
	"./number.svg": 9897,
	"./online.svg": 7197,
	"./password.svg": 5739,
	"./pdf.svg": 82,
	"./people.svg": 6116,
	"./peoples.svg": 975,
	"./phone.svg": 4971,
	"./post.svg": 7334,
	"./qq.svg": 9040,
	"./question.svg": 7370,
	"./radio.svg": 4515,
	"./rate.svg": 633,
	"./redis-list.svg": 8449,
	"./redis.svg": 7291,
	"./rengj.svg": 4829,
	"./row.svg": 854,
	"./search.svg": 9589,
	"./select.svg": 669,
	"./server.svg": 5954,
	"./shopping.svg": 7529,
	"./size.svg": 9394,
	"./skill.svg": 7824,
	"./slider.svg": 2862,
	"./star.svg": 1261,
	"./swagger.svg": 6996,
	"./switch.svg": 774,
	"./system.svg": 6955,
	"./tab.svg": 4658,
	"./table.svg": 8288,
	"./textarea.svg": 9120,
	"./theme.svg": 4326,
	"./time-range.svg": 2409,
	"./time.svg": 4570,
	"./tool.svg": 8486,
	"./tree-table.svg": 9606,
	"./tree.svg": 2545,
	"./upload.svg": 4129,
	"./user.svg": 1324,
	"./validCode.svg": 2838,
	"./wechat.svg": 675,
	"./zip.svg": 4072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;